import { useEffect, useRef } from 'react'
import { useState } from 'react'
import { Outlet, useMatches } from 'react-router-dom'
import CssBaseline from '@mui/material/CssBaseline'
import { ApplicationMainDrawer } from 'shared/widgets/ApplicationMainDrawer'
import { useAppDispatch, useAppSelector, useServiceWorker } from 'shared/hooks'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import Button from '@mui/material/Button'
import { ApplicationBottomNavigation } from '../../../shared/widgets/ApplicationBottomNavigation'
import { selectShowMainBackDrop, selectShowNotificationReminder, selectTitle, setApplicationBottomNavigationRef, setMode } from '../../../store/applicationSlice'
import { NotificationsSettingsView } from '../../../components/NotificationsSettingsView'
import { ApplicationMain } from '../../../shared/widgets/ApplicationMain'
import { ApplicationMainBar } from '../../../shared/widgets/ApplicationMainBar'
import { ApplicationMainContainer } from '../../../shared/widgets/ApplicationMainContainer'
import { ApplicationContentContainer } from '../../../shared/widgets/ApplicationContentContainer'
import { monitorRunResultApi } from 'services/monitorRunResult'
import { ApplicationMainTabs } from 'shared/widgets/ApplicationMainTabs'
import { useBreakpointUp } from 'shared/hooks/useBreakpointQueries'
import { NotificationsSettingsDialog } from 'features/notification/notificationsSettings/ui/NotificationsSettingsDialog'
import { Backdrop } from '@mui/material'

export const MainLayout = () => {
    const applicationBottomNavigationRef = useRef(null)
    const dispatch = useAppDispatch()
    const { waitingWorker, showReload, reloadPage } = useServiceWorker()
    const [open, setOpen] = useState<boolean>(false)
    const [notificationDialogOpen, setNotificationDialogOpen] = useState<boolean>(false)
    const [subscribed, setSubscribed] = useState<boolean>(false)
    const showNotificationReminder = useAppSelector(selectShowNotificationReminder)

    const checkNotifications = async () => {
        const registration = await navigator.serviceWorker.getRegistration()
        if (registration === undefined) {
            setSubscribed(false)
            setNotificationDialogOpen(true)
            return
        }

        const subscribed = await registration.pushManager.getSubscription()
        if (subscribed) {
            setSubscribed(true)
            return;
        } 

        setSubscribed(false)
        setNotificationDialogOpen(true)
    }

    useEffect(() => {
        if (showNotificationReminder === true || showNotificationReminder === undefined) {
            checkNotifications()
            return
        }

    }, [
        showNotificationReminder
    ])

    useEffect(() => {
        if (showReload && waitingWorker) {
            setOpen(true)

            return;
        }

        setOpen(false);
    }, [waitingWorker, showReload, reloadPage]);

    const handleClose = () => {
        setOpen(false)
    }

    const handleCancel = () => {
        setOpen(false)
    }

    const handleOk = () => {
        reloadPage(() => {
            setTimeout(() => {
                window.location.reload()
            }, 700)
        })
    }

    const handleNotificationDialogOk = () => {
        setNotificationDialogOpen(false)
    }

    useEffect(() => {
        dispatch(setApplicationBottomNavigationRef(applicationBottomNavigationRef.current))
    }, [
        applicationBottomNavigationRef, dispatch
    ])

    const title = useAppSelector(selectTitle);

    navigator.serviceWorker.onmessage = (event) => {
        const msgType: string = event.data.type
        switch (msgType) {
            case 'SUCCESS_MONITOR_RUN': {
                dispatch(monitorRunResultApi.util.invalidateTags(['MonitorRunsGrouped']));
                break;
            }
            default: {
                break;
            }
        }
    };


    const matches: any = useMatches();

    useEffect(() => {
        if (matches !== undefined && matches.length > 0) {
            if (matches[0]?.handle?.mode === 'property') {
                dispatch(setMode('property'))
                return
            }

            if (matches[0]?.handle?.mode === 'market') {
                dispatch(setMode('market'))
                return
            }

        }
 
    }, [
        matches, 
        dispatch
    ])

    const isXlWidthScreenOrMore = useBreakpointUp('xl')
    const showMainBackDrop: any = useAppSelector(selectShowMainBackDrop)

    return (
        <> 
            <title>{title || 'StrSpy'}</title>
            {!showReload && !waitingWorker && (
                    <ApplicationContentContainer>
                        <CssBaseline />
                        <ApplicationMainBar />
                        {
                        isXlWidthScreenOrMore && <ApplicationMainDrawer />
                        }
                            <ApplicationMainContainer>
                                <ApplicationMain>
                                    <Outlet />
                                    <Backdrop
                                        open={showMainBackDrop}
                                    />
                                </ApplicationMain>
                            <NotificationsSettingsDialog />
                        </ApplicationMainContainer>    
                        {
                        !isXlWidthScreenOrMore && <ApplicationBottomNavigation ref={applicationBottomNavigationRef} />
                        }              
                        </ApplicationContentContainer>
            )}
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogTitle id="responsive-dialog-title">
                    {"New version available"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Update to new version?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={handleCancel}>
                         Cancel
                    </Button>
                    <Button onClick={handleOk} autoFocus>
                        Ok
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}